import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, User, Settings, MessageCircle, Download } from "lucide-react";
import { Switch } from "./ui/switch";

export default function Header({ onLogin, onSearch }) {
  const [theme, setTheme] = useState(true);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#0a0a0c]/80 border-b border-white/5">
      <div className="max-w-[1500px] mx-auto px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="relative">
            <button className="relative p-2 rounded-full hover:bg-white/5 transition" aria-label="Notificações">
              <MessageCircle className="w-5 h-5 text-white/80" />
              <span className="absolute -top-0.5 -right-0.5 bg-red-600 text-white text-[10px] font-semibold rounded-full w-5 h-5 flex items-center justify-center">110</span>
            </button>
          </div>
          <a href="/" className="flex items-center gap-2 group">
            <img
              src="https://customer-assets.emergentagent.com/job_hardcore-lichterman-3/artifacts/zntek32k_images.png"
              alt="UniPlay UHD"
              className="w-11 h-11 rounded-xl object-cover shadow-lg shadow-black/40"
            />
            <span className="hidden sm:block text-xl font-extrabold text-white tracking-tight">
              UNIPLAY <span className="text-[10px] font-bold text-cyan-400 align-top">UHD</span>
            </span>
          </a>
        </div>

        <div className="flex items-center gap-2 md:gap-4">
          <button onClick={onSearch} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 hover:bg-white/10 transition text-sm text-white/80">
            <Search className="w-4 h-4" />
            <span className="hidden md:inline">Pesquisar...</span>
          </button>

          <Link
            to="/baixar"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/15 hover:bg-cyan-500/25 border border-cyan-500/40 text-cyan-300 text-sm font-semibold transition"
          >
            <Download className="w-4 h-4" />
            <span className="hidden md:inline">Baixar App</span>
          </Link>

          <a
            href="http://navegauni.top/login"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:brightness-110 text-white text-sm font-semibold shadow-lg shadow-cyan-500/30 transition"
          >
            Área Web
          </a>

          <Switch checked={theme} onCheckedChange={setTheme} className="data-[state=checked]:bg-red-600" />

          <button onClick={onLogin} className="p-2 rounded-full hover:bg-white/5 transition" aria-label="Login">
            <User className="w-5 h-5 text-white/80" />
          </button>

          <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5">
            <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" />
            <span className="text-xs font-semibold text-emerald-400">143</span>
          </div>

          <button className="p-2 rounded-full hover:bg-white/5 transition" aria-label="Configurações">
            <Settings className="w-5 h-5 text-white/80" />
          </button>

          <div className="glow-ring w-10 h-10">
            <img src="https://img.freepik.com/fotos-premium/stylist-de-cabelo-avatar-digital-inteligencia-artificial-gerativa_934475-9013.jpg" alt="Bruna" className="w-full h-full rounded-full object-cover" />
          </div>
        </div>
      </div>
    </header>
  );
}
